import type { RouteRecordRaw } from 'vue-router'
// import {Payment} from '../../pages/Payment.vue'


// import { Payment } from '../../pages/Payment.vue';
import Payment from '../../pages/Payment.vue';
import { ROUTES } from '@myorg/type-lib'

export const paymentRoute: RouteRecordRaw = {
  path: ROUTES.PAYMENT.PATH,
  name: ROUTES.PAYMENT.NAME,
  component: Payment,
}
